import { render, staticRenderFns } from "./commonDialog.vue?vue&type=template&id=8696d87c&scoped=true"
import script from "./commonDialog.vue?vue&type=script&lang=js"
export * from "./commonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8696d87c",
  null
  
)

export default component.exports